
export const User_data = {
  /// author & seo details
  authorName: "Arvind Choudhary",
  description: "Arvind's Portfolio",
  keywords:
    "Arvind Choudhary, Portfolio, Automation Engineer, Profile, Arvind, Choudhary, Automation, QA, Tester, Developer, Engineer",
};
